import * as am5 from '@amcharts/amcharts5';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import am5themes_Micro from '@amcharts/amcharts5/themes/Micro';
import { Injectable } from '@angular/core';
import {
    DatiqGraphXYTypes,
    IDatiqGraph
} from '../models';
import { DatiqAmcharts5ChartService } from './datiq-amcharts-5-chart.service';

@Injectable({
    providedIn: 'root',
})
export class DatiqAmcharts5RootService {
    constructor(private _chart: DatiqAmcharts5ChartService) {}

    create(rootElement: HTMLElement, settings: IDatiqGraph): am5.Root {
        const root: am5.Root = this.setRoot(rootElement);
        const chart: am5.Chart = this._chart.init(root, settings);

        this.setTheme(root, settings);

        return root;
    }

    setTheme(root: am5.Root, settings: IDatiqGraph) {
        root.setThemes([]);

        settings.xyType === DatiqGraphXYTypes.Miniature
            ? root.setThemes([
                  am5themes_Animated.new(root),
                  am5themes_Micro.new(root),
              ])
            : root.setThemes([
                  am5themes_Animated.new(root),
                  //   am5themes_Responsive.new(root),
              ]);
    }

    setRoot(rootElement: HTMLElement): am5.Root {
        return am5.Root.new(rootElement, {
            tooltipContainerBounds: {
                top: 150,
                bottom: 100,
                left: 100,
                right: 100,
            },
        });
    }

    update(root: am5.Root, settings: IDatiqGraph): am5.Root {
        this._chart.update(root, settings);

        return root;
    }
}
